var map = {
	"./de/warrior-name.png": "0qoR",
	"./en/warrior-name.png": "6o+7",
	"./es/warrior-name.png": "B7yE",
	"./fr/warrior-name.png": "Yp5m",
	"./ja/warrior-name.png": "p3NO",
	"./ko/warrior-name.png": "QIM7",
	"./pt/warrior-name.png": "H2az",
	"./ru/warrior-name.png": "b6lp",
	"./th/warrior-name.png": "I8bm",
	"./zh-Hant/warrior-name.png": "apKs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tslF";